export default "__VITE_ASSET__CzijhXI___"